import { FC } from 'react'

import { GeoMappingWithOptions } from './GeoMappingWithOptions'
import { useGeoMappingItems } from './hooks/useGeoMappingItems'
import { IGeoMappingProps } from './models/geoMappingProps'

export const GeoMapping: FC<IGeoMappingProps> = ({ allowedCountryCodes, ...rest }) => {
  /** -------------------- Variables ----------------------- */
  const geoMappings = useGeoMappingItems(allowedCountryCodes)

  return <GeoMappingWithOptions options={geoMappings} {...rest} />
}
